import { AUTOMATION_DECISION_LABELS, type AutomationDecision, type AutomationDecisionDTO } from '@hearth/shared';
import { Link } from 'react-router';
import { RelativeTime } from '../../components/crm';
import { Badge } from '../../components/ui';

export const DECISION_COLORS: Record<AutomationDecision, string> = {
  enrolled: 'sky',
  email_queued: 'green',
  skipped: 'slate',
  paused: 'amber',
  resumed: 'sky',
  stopped: 'red',
  completed: 'violet',
  blocked_at_send: 'red',
};

/** Automation history: one line per decision with its plain-language reason. */
export function DecisionList({
  items,
  showLead = true,
  showSequence = true,
  empty = 'No automation decisions yet.',
}: {
  items: readonly AutomationDecisionDTO[];
  showLead?: boolean;
  showSequence?: boolean;
  empty?: string;
}) {
  if (items.length === 0) return <p className="px-4 py-6 text-center text-[13px] text-slate-500">{empty}</p>;
  return (
    <ul className="divide-y divide-slate-100">
      {items.map((decision) => (
        <li key={decision.id} className="flex flex-wrap items-start gap-x-2 gap-y-1 px-4 py-2 text-[13px]">
          <Badge color={DECISION_COLORS[decision.decision]} size="sm">
            {AUTOMATION_DECISION_LABELS[decision.decision]}
          </Badge>
          {showLead && (
            <Link to={`/leads/${decision.businessId}`} className="font-medium text-slate-900 hover:text-ember-700">
              {decision.businessName}
            </Link>
          )}
          {showSequence && decision.sequenceId && (
            <Link to={`/automation/sequences/${decision.sequenceId}`} className="text-slate-500 hover:text-ember-700">
              {decision.sequenceName}
            </Link>
          )}
          <span className="min-w-0 basis-full text-slate-600 sm:basis-auto sm:flex-1">{decision.reason}</span>
          <RelativeTime value={decision.createdAt} className="text-xs text-slate-400" />
        </li>
      ))}
    </ul>
  );
}
